import { Link } from 'react-router-dom';

const projects = [
  {
    id: 1,
    title: 'Mağaza Cephesi Reklam Giydirme',
    category: 'Reklam Giydirme',
    img: '/images/projects/proj-1.webp',
    size: 'large',
  },
  {
    id: 2,
    title: 'Kurumsal Bina Cephe Lightbox',
    category: 'Dış Mekan',
    img: '/images/projects/proj-2.webp',
    size: 'medium',
  },
  {
    id: 3,
    title: 'AVM Dolak Lightbox Sistemi',
    category: 'Dolak Lightbox',
    img: '/images/projects/proj-3.webp',
    size: 'medium',
  },
  {
    id: 4,
    title: 'Restoran Menü Lightbox Paneli',
    category: 'Menü Lightbox',
    img: '/images/projects/proj-4.webp',
    size: 'medium',
  },
  {
    id: 5,
    title: 'Kurumsal Bina Logo Tabelası',
    category: 'Dış Mekan',
    img: '/images/projects/proj-5.webp',
    size: 'medium',
  },
  {
    id: 6,
    title: 'Eczane LED Işıklı Tabela',
    category: 'Dış Mekan',
    img: '/images/projects/proj-6.webp',
    size: 'large',
  },
  {
    id: 7,
    title: 'Otel Lobi Dekoratif Lightbox',
    category: 'İç Mekan',
    img: '/images/projects/proj-7.webp',
    size: 'medium',
  },
  {
    id: 8,
    title: 'Spor Salonu Logo Lightbox',
    category: 'İç Mekan',
    img: '/images/projects/proj-8.webp',
    size: 'medium',
  },
];

export default function Projects() {
  return (
    <section id="projects" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 text-red-600 text-sm font-semibold uppercase tracking-widest mb-3">
            <span className="w-8 h-0.5 bg-red-600 inline-block"></span>
            Referanslarımız
            <span className="w-8 h-0.5 bg-red-600 inline-block"></span>
          </div>
          <h2 className="text-4xl font-black text-gray-900 mb-4">Ürettiğimiz Lightbox Projeleri</h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            Türkiye genelinde tamamladığımız projelerden örnekler. Her biri özel tasarım ve üretim.
          </p>
        </div>

        {/* Mobile: simple 2-column grid */}
        <div className="grid grid-cols-2 gap-3 md:hidden">
          {projects.map((p) => (
            <div key={p.id} className="relative group overflow-hidden rounded-xl cursor-pointer">
              <img
                src={p.img}
                alt={p.title}
                className="w-full h-36 object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-2">
                <span className="bg-red-600 text-white text-xs font-semibold px-2 py-0.5 rounded-full">{p.category}</span>
                <h3 className="text-white font-bold text-xs mt-1 line-clamp-2">{p.title}</h3>
              </div>
            </div>
          ))}
        </div>

        {/* Desktop: masonry gallery */}
        <div className="hidden md:grid grid-cols-4 gap-4">
          {/* Row 1 - large + 2 medium */}
          <div className="col-span-2 row-span-2 relative group overflow-hidden rounded-2xl cursor-pointer">
            <img
              src={projects[0].img}
              alt={projects[0].title}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500 min-h-[280px]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
              <span className="bg-red-600 text-white text-xs font-semibold px-3 py-1 rounded-full">{projects[0].category}</span>
              <h3 className="text-white font-bold text-base mt-2">{projects[0].title}</h3>
            </div>
          </div>

          {projects.slice(1, 3).map((p) => (
            <div key={p.id} className="relative group overflow-hidden rounded-2xl cursor-pointer">
              <img
                src={p.img}
                alt={p.title}
                className="w-full h-[180px] object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <span className="bg-red-600 text-white text-xs font-semibold px-2 py-0.5 rounded-full">{p.category}</span>
                <h3 className="text-white font-bold text-sm mt-1">{p.title}</h3>
              </div>
            </div>
          ))}

          {/* Row 2 - 4 medium */}
          {projects.slice(3, 7).map((p) => (
            <div key={p.id} className="relative group overflow-hidden rounded-2xl cursor-pointer">
              <img
                src={p.img}
                alt={p.title}
                className="w-full h-[180px] object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <span className="bg-red-600 text-white text-xs font-semibold px-2 py-0.5 rounded-full">{p.category}</span>
                <h3 className="text-white font-bold text-sm mt-1">{p.title}</h3>
              </div>
            </div>
          ))}

          {/* Last wide */}
          <div className="col-span-2 relative group overflow-hidden rounded-2xl cursor-pointer">
            <img
              src={projects[7].img}
              alt={projects[7].title}
              className="w-full h-[180px] object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
              <span className="bg-red-600 text-white text-xs font-semibold px-3 py-1 rounded-full">{projects[7].category}</span>
              <h3 className="text-white font-bold text-base mt-2">{projects[7].title}</h3>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <Link
            to="/referanslar"
            className="inline-flex items-center gap-2 border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white font-bold px-8 py-3 rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            Tüm Projeleri Gör
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
